/**
 * Marcador de posición de la gráfica mientras se consulta la API.
 *
 * Ocupa el mismo espacio que el resultado real, así que el contenido no salta
 * cuando llegan los datos. Un spinner centrado sobre un contenedor vacío hace
 * exactamente lo contrario: colapsa la altura y luego la reconstruye.
 */

/** Alturas fijas para que las barras no parpadeen entre renders. */
const BARRAS = [45, 78, 62, 90, 55, 70];

const EsqueletoGrafica = ({ texto = "Consultando resultados…" }) => (
  <div className="mt-4 rounded-lg bg-white p-4 md:p-8" aria-busy="true" aria-live="polite">
    <div className="mb-4 flex flex-col gap-3 border-b pb-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="w-full sm:w-1/2">
        <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
        <div className="mt-2 h-5 w-4/5 animate-pulse rounded bg-gray-200" />
      </div>
      <div className="w-full space-y-2 sm:w-1/3">
        <div className="h-3 w-full animate-pulse rounded bg-gray-200" />
        <div className="h-3 w-2/3 animate-pulse rounded bg-gray-200 sm:ml-auto" />
      </div>
    </div>

    <div className="rounded-lg border border-gray-100 p-6 shadow-sm">
      <div className="flex h-56 items-end justify-around gap-3 border-b border-l border-gray-200 px-2">
        {BARRAS.map((altura, indice) => (
          <div
            key={indice}
            className="w-full animate-pulse rounded-t bg-blue-100"
            style={{ height: `${altura}%`, animationDelay: `${indice * 120}ms` }}
          />
        ))}
      </div>

      <div className="mt-3 flex justify-around gap-3">
        {BARRAS.map((_, indice) => (
          <div key={indice} className="h-3 w-full animate-pulse rounded bg-gray-200" />
        ))}
      </div>

      <p className="mt-6 text-center text-sm font-medium text-gray-500">{texto}</p>
    </div>
  </div>
);

export default EsqueletoGrafica;
